// THREAT PROFILES landing page component 
//*******************************************************************
//*******************************************************************
//Importing Dependencies:
//external and package dependencies 
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//component dependencies
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import FullWidthImage from '../../components/FullWidthImage'
import TextBlock from '../../components/textblock'
import Header from '../../components/Header'
import ContentsTable from '../../components/ContentsTable'
import ContentSection from '../../components/ContentSection'
import ContentGridNew from "../../components/ContentGridNew"
import BodySection from '../../components/BodySection'
import IconBannerHeader from '../../components/IconBannerHeader'
import IconHeader from '../../components/IconHeader'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************
const threatProfilesPage = ({data}) => {
    
    const threatProfiles = data.threat_profiles.edges 
   
    return (
        
        <div>
            
             <Helmet>
                   <title>NJCCIC Threat Profiles</title>
                    <meta name="description" content="The NJCCIC has gathered cyber threat intelligence information to develop specific cyber threat profiles"/>
            </Helmet>
            <Heading/>
            
            <Navbar/>            
        
            {threatProfiles.map(({ node: {page_title, introductory_text, subheader, headers, content_group, content_group_botnets, content_group_mobile_malware, content_group_ransomware, content_group_trojans, content_group_other_malware, image, image_2} }) => (
        
                <div class="container-fluid">
        
                    <PageHeader elementClass="pageHeader centerText" title={page_title}/>
                    
                    <div class="container containerWidth">
                        
                        <div class="row">
                            
                            <TextBlock elementClass="standardText introPadding" text={introductory_text}/>
                            
                        </div>
                        
                    </div>
                    
                    <ContentsTable testClass="testClass container containerWidth" elementClass="col-12 col-md-3 grid5 blocks block2 block2Alt" dangerousClass="standardText blockText margin btnWidth" headerStyles="header contentTitle" data={content_group} iconId="iconsGroup"/>
        
                    <FullWidthImage id="variantsBanner" src={image}/>
                    
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[0].section_name} id="botnets"/>
                    
                    <BodySection data={content_group_botnets}/>
                    
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[1].section_name} id="mobile-malware"/>
                    
                    <BodySection data={content_group_mobile_malware}/>
                    
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[2].section_name} id="ransomware"/>
                    
                    <BodySection data={content_group_ransomware}/>
                    
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[3].section_name} id="trojans"/>
                    
                    <BodySection data={content_group_trojans}/>
                    
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title={headers[4].section_name} id="other-malware"/>
                    
                    <BodySection data={content_group_other_malware}/>
                    
                    <Header />
                
                </div>
        
            ))}  
        	
            <Footer/>
            
           
        </div>   

    ) 
     
}
//*******************************************************************
//*******************************************************************
export const query = graphql`
    query {
        threat_profiles: allButterPage(filter: { slug: { eq: "threat-profiles" } }) {
            edges {
                node {
                    seo_title
                    page_title
                    introductory_text
                    subheader
                    image
                    image_2
                    headers {
                        section_name
                    }
                    content_group {
                        section_name
                        data_target
                        icon
                        text
                    }
                    content_group_botnets {
                        icon 
                        section_name
                        preview_text
                        toggle_target
                        main_text
                    }
                    content_group_mobile_malware {
                        icon 
                        section_name
                        preview_text
                        toggle_target
                        main_text
                    }
                    content_group_ransomware {
                        icon 
                        section_name
                        preview_text
                        toggle_target
                        main_text
                    }
                    content_group_trojans {
                        icon 
                        section_name
                        preview_text
                        toggle_target
                        main_text
                    }
                    content_group_other_malware {
                        icon 
                        section_name
                        preview_text
                        toggle_target
                        main_text
                    }
                }
            }
        }
    }
`
export default threatProfilesPage      
//*******************************************************************
//*******************************************************************